<template>
  <v-list-item class="list-item pa-0">
    <v-list-item-icon class="list-item__icon my-0 mr-2">
      <img :src="require('@/assets/icons/'+icon)" />
    </v-list-item-icon>
    <v-list-item-content class="pa-0">
      <v-list-item-title class="list-item__title pa-0">
        {{ title }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
export default {
  props: {
    icon: String,
    title: String,
  },
};
</script>
<style lang="scss" scoped>
.list-item {
  min-height: 19px;
}

.v-list .list-item__icon {
  height: 19px;
  width: auto;
  min-width: auto;
}

.v-list-item .v-list-item__title.list-item__title {
  overflow: hidden;
  color: var(--v-primaryText-base);
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 600;
}
</style>